<template>
  <div>
    <hd></hd>
    <bread-crumb v-show="isShowBread"></bread-crumb>
    <router-view class="bodyHeight"></router-view>
    <ft></ft>
  </div>
</template>
<script>
import hd from "./components/hd";
import ft from "./components/ft";
import breadCrumb from "./components/Breadcrumb";
export default {
  data() {
    return {
      isShowBread: false,
      route: {},
    };
  },
  components: {
    hd,
    ft,
    breadCrumb,
  },

  methods: {},
  mounted() {
  
  },
  beforeRouteEnter(to, from, next){
    next( vm => { 
      let routeName = vm.$route.name;
       if (routeName == "home" || routeName == "index") {
      vm.isShowBread = false;
    } else {
      vm.isShowBread = true;
    }
    });
    
    
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name == "home" || to.name == "index") {
      this.isShowBread = false;
    } else {
      this.isShowBread = true;
    }
    next();
  },
};
</script>

<!-- 样式已迁移到 src/styles/layouts/_main.less -->
